"use client";

import { useRouter } from "next/navigation";
import { type ChangeEventHandler, type FormEventHandler, useState } from "react";
import { twMerge } from "tailwind-merge";

import { MAX_SEARCH_TERM_LENGTH, SEARCH_PARAMS, STATIC_PATH } from "@/globals";
import { messages } from "@/globals.content";
import { progressSingleton } from "@/singletons/progress.singleton";
import { BUTTON_STYLES } from "@/styles/buttons";
import { TYPO_STYLES } from "@/styles/typography";

export const HeaderSearchFieldView = () => {
    const router = useRouter();

    const uRLSearchParams = new URLSearchParams();

    const [searchValue, setSearchValue] = useState(uRLSearchParams.get(SEARCH_PARAMS.search) ?? "");

    const handleSearch: ChangeEventHandler<HTMLInputElement> = (e) => {
        setSearchValue(e.currentTarget.value);
    };

    const handleSubmit: FormEventHandler<HTMLFormElement> = (e) => {
        progressSingleton.createProgress().run(200).finish(6000);
        e.preventDefault();
        setSearchValue("");
        uRLSearchParams.set(SEARCH_PARAMS.search, searchValue);
        router.push(STATIC_PATH.search + `?${uRLSearchParams.toString()}`);
    };

    return (
        <form className="flex gap-2 w-full" role="search" onSubmit={handleSubmit}>
            <div className="relative flex-1">
                <label htmlFor="search" className="hidden">
                    {messages.app.search.title}
                </label>
                {searchValue && (
                    <button
                        className={twMerge("absolute right-2.5 top-2.5 ")}
                        type="reset"
                        onClick={() => setSearchValue("")}
                    >
                        <span
                            className={twMerge(TYPO_STYLES.icon(), "text-2xl")}
                            aria-label={messages.search.reset}
                            title={messages.search.reset}
                        >
                            {String.fromCharCode(Number("0xe91b"))}
                        </span>
                    </button>
                )}
                <input
                    id="search"
                    className={twMerge(
                        searchValue ? "pr-12" : "pr-2.5",
                        "rounded-tl rounded-tr block h-full w-full pl-2.5 text-right overflow-ellipsis placeholder:italic bg-transparent border-b border-brandDark text-base font-light",
                        "aria-invalid:border-b-2 aria-invalid:border-error focus:border-b-2 focus-visible:outline-none",
                    )}
                    maxLength={MAX_SEARCH_TERM_LENGTH}
                    value={searchValue}
                    name="search"
                    placeholder={messages.app.search.placeholder}
                    type="text"
                    onChange={handleSearch}
                    pattern=".*\S.*"
                    title="Bitte geben Sie einen gülten Wert ein."
                />
            </div>
            <button
                className={BUTTON_STYLES.primary()}
                aria-label={messages.search.button}
                type="submit"
            >
                <span
                    className={twMerge(TYPO_STYLES.icon(), "text-2xl")}
                    aria-label={messages.search.startSearch}
                    title={messages.search.startSearch}
                >
                    {String.fromCharCode(Number("0xe971"))}
                </span>
            </button>
        </form>
    );
};
